module.exports = __webpack_public_path__ + "images/FUSA_icons/080-box-1.6d27642bfb623e8214d9e6a07c927064.svg";